/* tslint:disable */
/* eslint-disable */
/**
 * Munchi Dashboard Server Api
 * The Munchi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ActionPasscodePermissionsDto } from '../models';
// @ts-ignore
import type { ActionPasscodePinDto } from '../models';
// @ts-ignore
import type { ActionPasscodeResponseDto } from '../models';
// @ts-ignore
import type { CreateActionPasscodeDto } from '../models';
/**
 * ActionPasscodesApi - axios parameter creator
 * @export
 */
export const ActionPasscodesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} businessId 
         * @param {string} passcodeId 
         * @param {ActionPasscodePermissionsDto} actionPasscodePermissionsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeActionPasscodePermissions: async (businessId: number, passcodeId: string, actionPasscodePermissionsDto: ActionPasscodePermissionsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('changeActionPasscodePermissions', 'businessId', businessId)
            // verify required parameter 'passcodeId' is not null or undefined
            assertParamExists('changeActionPasscodePermissions', 'passcodeId', passcodeId)
            // verify required parameter 'actionPasscodePermissionsDto' is not null or undefined
            assertParamExists('changeActionPasscodePermissions', 'actionPasscodePermissionsDto', actionPasscodePermissionsDto)
            const localVarPath = `/api/v1/businesses/{businessId}/action-passcodes/{passcodeId}/permissions`
                .replace(`{${"businessId"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"passcodeId"}}`, encodeURIComponent(String(passcodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(actionPasscodePermissionsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} businessId 
         * @param {string} passcodeId 
         * @param {ActionPasscodePinDto} actionPasscodePinDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeActionPasscodePin: async (businessId: number, passcodeId: string, actionPasscodePinDto: ActionPasscodePinDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('changeActionPasscodePin', 'businessId', businessId)
            // verify required parameter 'passcodeId' is not null or undefined
            assertParamExists('changeActionPasscodePin', 'passcodeId', passcodeId)
            // verify required parameter 'actionPasscodePinDto' is not null or undefined
            assertParamExists('changeActionPasscodePin', 'actionPasscodePinDto', actionPasscodePinDto)
            const localVarPath = `/api/v1/businesses/{businessId}/action-passcodes/{passcodeId}/pin`
                .replace(`{${"businessId"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"passcodeId"}}`, encodeURIComponent(String(passcodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(actionPasscodePinDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} businessId 
         * @param {CreateActionPasscodeDto} createActionPasscodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActionPasscode: async (businessId: number, createActionPasscodeDto: CreateActionPasscodeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('createActionPasscode', 'businessId', businessId)
            // verify required parameter 'createActionPasscodeDto' is not null or undefined
            assertParamExists('createActionPasscode', 'createActionPasscodeDto', createActionPasscodeDto)
            const localVarPath = `/api/v1/businesses/{businessId}/action-passcodes`
                .replace(`{${"businessId"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createActionPasscodeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} businessId 
         * @param {string} passcodeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActionPasscode: async (businessId: number, passcodeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('deleteActionPasscode', 'businessId', businessId)
            // verify required parameter 'passcodeId' is not null or undefined
            assertParamExists('deleteActionPasscode', 'passcodeId', passcodeId)
            const localVarPath = `/api/v1/businesses/{businessId}/action-passcodes/{passcodeId}`
                .replace(`{${"businessId"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"passcodeId"}}`, encodeURIComponent(String(passcodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActionPasscodes: async (businessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('listActionPasscodes', 'businessId', businessId)
            const localVarPath = `/api/v1/businesses/{businessId}/action-passcodes`
                .replace(`{${"businessId"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActionPasscodesApi - functional programming interface
 * @export
 */
export const ActionPasscodesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActionPasscodesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} businessId 
         * @param {string} passcodeId 
         * @param {ActionPasscodePermissionsDto} actionPasscodePermissionsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeActionPasscodePermissions(businessId: number, passcodeId: string, actionPasscodePermissionsDto: ActionPasscodePermissionsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionPasscodeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeActionPasscodePermissions(businessId, passcodeId, actionPasscodePermissionsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionPasscodesApi.changeActionPasscodePermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} businessId 
         * @param {string} passcodeId 
         * @param {ActionPasscodePinDto} actionPasscodePinDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeActionPasscodePin(businessId: number, passcodeId: string, actionPasscodePinDto: ActionPasscodePinDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionPasscodeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeActionPasscodePin(businessId, passcodeId, actionPasscodePinDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionPasscodesApi.changeActionPasscodePin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} businessId 
         * @param {CreateActionPasscodeDto} createActionPasscodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createActionPasscode(businessId: number, createActionPasscodeDto: CreateActionPasscodeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionPasscodeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createActionPasscode(businessId, createActionPasscodeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionPasscodesApi.createActionPasscode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} businessId 
         * @param {string} passcodeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteActionPasscode(businessId: number, passcodeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteActionPasscode(businessId, passcodeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionPasscodesApi.deleteActionPasscode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listActionPasscodes(businessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActionPasscodeResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listActionPasscodes(businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionPasscodesApi.listActionPasscodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActionPasscodesApi - factory interface
 * @export
 */
export const ActionPasscodesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActionPasscodesApiFp(configuration)
    return {
        /**
         * 
         * @param {number} businessId 
         * @param {string} passcodeId 
         * @param {ActionPasscodePermissionsDto} actionPasscodePermissionsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeActionPasscodePermissions(businessId: number, passcodeId: string, actionPasscodePermissionsDto: ActionPasscodePermissionsDto, options?: RawAxiosRequestConfig): AxiosPromise<ActionPasscodeResponseDto> {
            return localVarFp.changeActionPasscodePermissions(businessId, passcodeId, actionPasscodePermissionsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} businessId 
         * @param {string} passcodeId 
         * @param {ActionPasscodePinDto} actionPasscodePinDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeActionPasscodePin(businessId: number, passcodeId: string, actionPasscodePinDto: ActionPasscodePinDto, options?: RawAxiosRequestConfig): AxiosPromise<ActionPasscodeResponseDto> {
            return localVarFp.changeActionPasscodePin(businessId, passcodeId, actionPasscodePinDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} businessId 
         * @param {CreateActionPasscodeDto} createActionPasscodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActionPasscode(businessId: number, createActionPasscodeDto: CreateActionPasscodeDto, options?: RawAxiosRequestConfig): AxiosPromise<ActionPasscodeResponseDto> {
            return localVarFp.createActionPasscode(businessId, createActionPasscodeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} businessId 
         * @param {string} passcodeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActionPasscode(businessId: number, passcodeId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteActionPasscode(businessId, passcodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActionPasscodes(businessId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ActionPasscodeResponseDto>> {
            return localVarFp.listActionPasscodes(businessId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActionPasscodesApi - object-oriented interface
 * @export
 * @class ActionPasscodesApi
 * @extends {BaseAPI}
 */
export class ActionPasscodesApi extends BaseAPI {
    /**
     * 
     * @param {number} businessId 
     * @param {string} passcodeId 
     * @param {ActionPasscodePermissionsDto} actionPasscodePermissionsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionPasscodesApi
     */
    public changeActionPasscodePermissions(businessId: number, passcodeId: string, actionPasscodePermissionsDto: ActionPasscodePermissionsDto, options?: RawAxiosRequestConfig) {
        return ActionPasscodesApiFp(this.configuration).changeActionPasscodePermissions(businessId, passcodeId, actionPasscodePermissionsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} businessId 
     * @param {string} passcodeId 
     * @param {ActionPasscodePinDto} actionPasscodePinDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionPasscodesApi
     */
    public changeActionPasscodePin(businessId: number, passcodeId: string, actionPasscodePinDto: ActionPasscodePinDto, options?: RawAxiosRequestConfig) {
        return ActionPasscodesApiFp(this.configuration).changeActionPasscodePin(businessId, passcodeId, actionPasscodePinDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} businessId 
     * @param {CreateActionPasscodeDto} createActionPasscodeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionPasscodesApi
     */
    public createActionPasscode(businessId: number, createActionPasscodeDto: CreateActionPasscodeDto, options?: RawAxiosRequestConfig) {
        return ActionPasscodesApiFp(this.configuration).createActionPasscode(businessId, createActionPasscodeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} businessId 
     * @param {string} passcodeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionPasscodesApi
     */
    public deleteActionPasscode(businessId: number, passcodeId: string, options?: RawAxiosRequestConfig) {
        return ActionPasscodesApiFp(this.configuration).deleteActionPasscode(businessId, passcodeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} businessId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionPasscodesApi
     */
    public listActionPasscodes(businessId: number, options?: RawAxiosRequestConfig) {
        return ActionPasscodesApiFp(this.configuration).listActionPasscodes(businessId, options).then((request) => request(this.axios, this.basePath));
    }
}

